export default "__VITE_ASSET__fdab671e__"